import { LogoutOutlined } from "@ant-design/icons";
import { Layout, Menu, Typography } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

import { useApplicationContext } from "./ApplicationContext";

export const MainLayout: React.FC<{}> = () => {
  const { session, setSessionToken } = useApplicationContext();

  const location = useLocation();
  const [openedKey, setOpenedKey] = useState<string[]>([""]);
  const [selectedKey, setSelectedKey] = useState<string[]>([""]);

  const handleSignout = (e: any) => {
    e.preventDefault();
    setSessionToken("", false);
    return false;
  };

  useEffect(() => {
    if (location.pathname.startsWith("/global")) {
      setOpenedKey(["global"]);

      if (session.currentUser.role === "ADMIN") {
        if (location.pathname.startsWith("/global/stats")) setSelectedKey(["global_stats"]);
        if (location.pathname.startsWith("/global/users")) setSelectedKey(["global_users"]);
        if (location.pathname.startsWith("/global/user_brands")) setSelectedKey(["global_user_brands"]);
        if (location.pathname.startsWith("/global/orders")) setSelectedKey(["global_orders"]);
        if (location.pathname.startsWith("/global/carts")) setSelectedKey(["global_carts"]);
        if (location.pathname.startsWith("/global/items")) setSelectedKey(["global_items"]);
        if (location.pathname.startsWith("/global/stocks")) setSelectedKey(["global_stocks"]);
        if (location.pathname.startsWith("/global/seasons")) setSelectedKey(["global_seasons"]);
        if (location.pathname.startsWith("/global/brands")) setSelectedKey(["global_brands"]);
        if (location.pathname.startsWith("/global/lines")) setSelectedKey(["global_lines"]);
        if (location.pathname.startsWith("/global/attributes")) setSelectedKey(["global_attributes"]);
        if (location.pathname.startsWith("/global/sessions")) setSelectedKey(["global_sessions"]);
      } else if (session.currentUser.role === "SALESPERSON") {
        if (location.pathname.startsWith("/global/stats")) setSelectedKey(["global_stats"]);
        if (location.pathname.startsWith("/global/customers")) setSelectedKey(["global_customers"]);
        if (location.pathname.startsWith("/global/orders")) setSelectedKey(["global_orders"]);
        if (location.pathname.startsWith("/global/carts")) setSelectedKey(["global_carts"]);
        if (location.pathname.startsWith("/global/sessions")) setSelectedKey(["global_sessions"]);
      }
    } else {
      setOpenedKey([""]);
      setSelectedKey([""]);
    }
  }, [session.currentUser.role, location.pathname]);

  return (
    <Layout className="layout-main">
      <Layout.Sider theme="light" width={"250px"} breakpoint="lg" collapsedWidth="0">
        <div className="sider-wrapper">
          <Menu
            mode="inline"
            className="top"
            key={`${openedKey}_${selectedKey}`}
            defaultOpenKeys={openedKey}
            defaultSelectedKeys={selectedKey}
          >
            <div className="logo">
              <NavLink to="/">
                <img
                  src="/images/sign-in-logo.png"
                  alt="PGN International"
                  style={{
                    maxWidth: "none",
                    marginLeft: "-100%",
                    height: "60px",
                    padding: "10px 30px",
                  }}
                />
              </NavLink>
            </div>

            {session.currentUser.role === "ADMIN" ? (
              <Fragment>
                <Menu.Item key="global_stats">
                  <NavLink to="/global/stats">
                    <span>Stats</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_users">
                  <NavLink to="/global/users">
                    <span>Users</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_sessions">
                  <NavLink to="/global/sessions">
                    <span>Accesses</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_user_brands">
                  <NavLink to="/global/user_brands">
                    <span>User Brands</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_orders">
                  <NavLink to="/global/orders">
                    <span>Orders</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_carts">
                  <NavLink to="/global/carts">
                    <span>Carts</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_items">
                  <NavLink to="/global/items">
                    <span>Items</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_stocks">
                  <NavLink to="/global/stocks">
                    <span>Stocks</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_brands">
                  <NavLink to="/global/brands">
                    <span>Brands</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_seasons">
                  <NavLink to="/global/seasons">
                    <span>Seasons</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_lines">
                  <NavLink to="/global/lines">
                    <span>Lines</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_attributes">
                  <NavLink to="/global/attributes">
                    <span>Attributes</span>
                  </NavLink>
                </Menu.Item>
              </Fragment>
            ) : (
              <Fragment>
                <Menu.Item key="global_stats">
                  <NavLink to="/global/stats">
                    <span>Stats</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_customers">
                  <NavLink to="/global/customers">
                    <span>Customers</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_sessions">
                  <NavLink to="/global/sessions">
                    <span>Accesses</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_orders">
                  <NavLink to="/global/orders">
                    <span>Orders</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="global_carts">
                  <NavLink to="/global/carts">
                    <span>Carts</span>
                  </NavLink>
                </Menu.Item>
              </Fragment>
            )}
          </Menu>
          <Menu>
            <Menu.Item key="logout">
              <NavLink to="#" onClick={handleSignout}>
                <Typography.Text type="danger">
                  <LogoutOutlined />
                  <span> Sign out</span>
                </Typography.Text>
              </NavLink>
            </Menu.Item>
          </Menu>
        </div>
      </Layout.Sider>
      <Layout>
        <Outlet />
      </Layout>
    </Layout>
  );
};
